@if (isShowingRouteLoadIndicator && userLoggedIn) {
<div class="router-load-spinner-overlay">
  <i class="fa fa-circle-o-notch fa-spin"></i>
</div>
}

<div class="d-flex flex-fill">
  @if (showMenu) {
  <acs-primary-nav-v class="d-flex flex-column"></acs-primary-nav-v>
  }

  <div id="content-column" class="d-flex flex-column flex-fill">
    <mat-toolbar class="options-bar">
      <div class="d-flex flex-row align-items-center h-100">
        @if (userLoggedIn) {
        <button mat-button (click)="toggleMenu()" class="toolbar-secondary-button h-100">
          <mat-icon><fa-icon [icon]="toggleMenuIcon" aria-label="Change Menu"></fa-icon></mat-icon>
        </button>
        } @if (userLoggedIn && !adminOnly) {
        <button
          mat-button
          (click)="toggleWindowPin()"
          class="toolbar-secondary-button h-100"
          aria-label="Pin Window"
        >
          <mat-icon color="{{ pinColor }}"><fa-icon [icon]="thumbTackIcon"></fa-icon></mat-icon>
        </button>
        }
        <div id="pageTitle" class="pl-3">
          @if(!versionChanged) {
          <span>
            {{ title }}
          </span>
          } @else {
          <span>Update Available - Refresh Browser</span>
          }
        </div>

        @if (userLoggedIn && !adminOnly) {
        <button
          mat-button
          (click)="openInNewWindow()"
          class="toolbar-secondary-button h-100"
          aria-label="Open the current page in a new window"
        >
          <mat-icon fontIcon="fa-external-link" class="fa"></mat-icon>
        </button>
        }
      </div>
      <acs-toolbar class="d-flex justify-content-end overflow-auto ms-auto h-100"></acs-toolbar>
    </mat-toolbar>
    <mat-divider></mat-divider>

    @if (dispatcherConnectionStatus$ | async; as dispatcherConnectionStatus) {
    <div
      class="dispatcher-connection-banner"
      [class.disconnected]="
        dispatcherConnectionStatus === dispatcherConnectionStatuses.Disconnected
      "
      role="status"
      aria-live="polite"
    >
      <mat-icon
        class="dispatcher-connection-icon fa fa-fw"
        [class.fa-circle-o-notch]="
          dispatcherConnectionStatus === dispatcherConnectionStatuses.Connecting
        "
        [class.fa-spin]="dispatcherConnectionStatus === dispatcherConnectionStatuses.Connecting"
        [class.fa-exclamation-triangle]="
          dispatcherConnectionStatus === dispatcherConnectionStatuses.Disconnected
        "
      ></mat-icon>

      <div class="dispatcher-connection-content">
        @if (dispatcherConnectionStatus === dispatcherConnectionStatuses.Connecting) {
        <span>Connecting to Dispatcher...</span>
        } @else {
        <span>Unable to connect to the Dispatcher.</span>
        <button mat-stroked-button type="button" (click)="retryDispatcherConnection()">
          Retry
        </button>
        }
      </div>
    </div>
    }

    <div id="content" class="page-content d-flex flex-column flex-fill">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
